<div class="close-icon" mat-button (click)="onClose()"></div>
<div>
  <h2 mat-dialog-title style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Set Device Position</h2>
  <mat-dialog-content>
    <div>
      <mat-select [(ngModel)]="currentDiagram" (ngModelChange)="onDiagramChange(currentDiagram)">
        @for (diagram of diagrams; track diagram.id) {
          <mat-option [value]="diagram">{{diagram.name}}</mat-option>
        }
      </mat-select>
    </div>
    <div>
      @if(currentDiagram.diagram3dUrls) {
        <div *ngIf="currentDiagram.diagram3d != null">
          <viewer-3d [modelUrls]="currentDiagram.diagram3dUrls"></viewer-3d>
        </div>
      } @else {
        <div (click)="setPosition($event)" style="position: relative;">
          <img style="max-width: 100%" [src]="currentDiagram.imageUrl" />
          @if (position) {
            <div style="position: absolute; transform: translate(-50%, -90%); pointer-events: none;" [ngStyle]="{left: position.x * 100 + '%', top: position.y * 100 + '%'}">
              <svg width="32px" height="32px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"
                   style="z-index: 10;
            filter: drop-shadow(1px 1px 0px #ffffff)
                    drop-shadow(-1px -1px 0px #ffffff)
                    drop-shadow(1px -1px 0px #ffffff)
                    drop-shadow(-1px 1px 0px #ffffff)
                    drop-shadow(0px 2px 3px rgba(0,0,0,0.6));">
                <path d="M16.001 1.072c5.291 0 9.596 4.305 9.596 9.597 0 1.683-0.446 3.341-1.29 4.799l-8.307 14.394-8.308-14.395c-0.843-1.456-1.289-3.115-1.289-4.798 0-5.292 4.305-9.597 9.597-9.597zM16.001 14.4c2.058 0 3.731-1.674 3.731-3.731s-1.674-3.731-3.731-3.731c-2.058 0-3.732 1.674-3.732 3.731s1.674 3.731 3.732 3.731zM16.001 0.006c-5.889 0-10.663 4.775-10.663 10.663 0 1.945 0.523 3.762 1.432 5.332l9.23 15.994 9.23-15.994c0.909-1.57 1.432-3.387 1.432-5.332 0-5.888-4.774-10.663-10.662-10.663v0zM16.001 13.334c-1.472 0-2.666-1.193-2.666-2.665 0-1.471 1.194-2.665 2.666-2.665s2.665 1.194 2.665 2.665c0 1.472-1.193 2.665-2.665 2.665v0z"
                      style="stroke: #800080; fill: #800080;">
                </path>
              </svg>
            </div>
          }
        </div>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button (click)="save()" style="border-radius: 6px;">Save
    </button>
    <button mat-raised-button style="border-radius: 6px;" (click)="onClose()">Cancel</button>
  </mat-dialog-actions>
</div>
